export default {
  DISMISS_NEW_FEATURES: '@HOME_DISMISS_NEW_FEATURES',

  ORDER_STATUSES_LOADING: '@HOME_ORDER_STATUSES_LOADING',
  ORDER_STATUSES_SUCCESS: '@HOME_ORDER_STATUSES_SUCCESS',
  ORDER_STATUSES_ERROR: '@HOME_ORDER_STATUSES_ERROR',

  SELECT_STORE: '@HOME_SELECT_STORE',
  RESET_STORE: '@HOME_RESET_STORE',
};
